var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 160,
    r: 160,
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffda44",
    d: "m87.57 97.39 13.81 42.51h44.71l-36.17 26.28 13.82 42.52-36.17-26.28L51.4 208.7l13.82-42.52-36.17-26.28h44.71l13.81-42.51zm87.07 141.4-13.57-9.85-13.56 9.85 5.18-15.94-13.56-9.85h16.76l5.18-15.95 5.19 15.95h16.76l-13.56 9.85 5.18 15.94zm35.38-48.69h-16.77l-5.18 15.94-5.18-15.94h-16.76l13.56-9.86-5.18-15.94 13.56 9.85 13.57-9.85-5.19 15.94 13.57 9.86zm0-60.2-13.57 9.86 5.18 15.94-13.56-9.85-13.56 9.85 5.18-15.94-13.56-9.86h16.76l5.18-15.94 5.18 15.94h16.77zm-35.38-48.69-5.18 15.94 13.56 9.85h-16.76l-5.18 15.95-5.19-15.95-16.76.01 13.56-9.86-5.18-15.94 13.56 9.85 13.57-9.85z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChina);
export default __webpack_public_path__ + "static/media/China.a82b96b73d904a24455a2fd376f1f402.svg";
export { ForwardRef as ReactComponent };